import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { Form, FormGroup, Button, Input } from "reactstrap";
import MyLoader from "./util/loader";
import Api from "./api/api";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";

const AddEquipment = () => {
  const history = useHistory();
  const location = useLocation();
  const model = location.state.model;
  const editMode = model != null;

  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [mainShot, setMainShot] = useState(null);
  const [mainShotUrl, setMainShotUrl] = useState(null);
  const [loader, setLoader] = useState(false);
  const addMainShot = useRef(null);

  useEffect(() => {
    if (editMode) {
      setTitle(model.title);
      setDetail(model.detail);
      setMainShotUrl(model.image);
    }
  }, []);

  const saveEquipment = () => {
    if (title === "" || detail === "") {
      showToast("error", "Please fill complete form!");
      return;
    }
    setLoader(true);
    if (!editMode) {
      if (mainShot == null) {
        showToast("error", "Please choose photo!");
        return;
      }
      Api.addEquipmentNeeds(
        title,
        detail,
        mainShot,
        (response) => {
          console.log(JSON.stringify(response));
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Equipment added!");
            setTitle("");
            setDetail("");
            setMainShot(null);
            setMainShotUrl(null);
            history.goBack();
          } else {
            showToast("error", "Failed!");
          }
        },
        (error) => {
          setLoader(false);
        }
      );
    } else {
      Api.updateEquipmentNeeds(
        model.id,
        title,
        detail,
        mainShot,
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Equipment updated!");
            history.goBack();
          } else {
            showToast("error", "Failed!");
          }
        },
        (error) => {
          setLoader(false);
        }
      );
    }
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>
          {editMode ? "Edit" : "Add"} Equipment
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 15,
        }}
      >
        <img
          src={mainShotUrl}
          style={{
            width: 200,
            height: 150,
            marginBottom: 10,
            marginTop: 20,
            objectFit: "contain  ",
          }}
        />
        <Button
          style={{ marginTop: 0, fontSize: 16 }}
          className="btn-block"
          onClick={() => {
            addMainShot.current.click();
          }}
        >
          Choose Photo
        </Button>
        <input
          type="file"
          style={{ display: "none" }}
          ref={addMainShot}
          onChange={(event) => {
            setMainShot(event.target.files[0]);
            setMainShotUrl(URL.createObjectURL(event.target.files[0]));
          }}
        />
        <Form className="form" style={{ width: 500, marginTop: 20 }}>
          <FormGroup>
            <Input
              type="text"
              placeholder="Enter Title"
              value={title}
              onChange={(event) => {
                setTitle(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <Input
              type="textarea"
              placeholder="Enter Detail"
              value={detail}
              onChange={(event) => {
                setDetail(event.target.value);
              }}
            />
          </FormGroup>
          <Button
            style={{ marginTop: 20, fontSize: 16 }}
            className="btn-block btn-dark"
            onClick={() => {
              saveEquipment();
            }}
          >
            Save Equipment
          </Button>
        </Form>
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default AddEquipment;
